/**
 * App-wide "appointments changed" notifier.
 *
 * Surfaces that write appointment schedule data call this after the server
 * write succeeds; views showing schedule data listen and refetch. Routy is the
 * main reason it exists: it writes while other surfaces are already on screen
 * (the Timeline is usually open behind the chat panel), and those views fetch
 * once and hold — so events Routy just cleared stay visible, which the
 * operator quite reasonably reads as the removal having failed.
 *
 * On the web this is a window event, which every listener can subscribe to
 * directly. Mobile has its own module at this same path backed by an in-memory
 * emitter, so the Routy logic synced between the two platforms can call
 * `notifyAppointmentsChanged()` without knowing which one it is running on.
 */
export const APPOINTMENTS_CHANGED_EVENT = 'routemize:schedule-changed';

export function notifyAppointmentsChanged(): void {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;
  window.dispatchEvent(new Event(APPOINTMENTS_CHANGED_EVENT));
}
